import type { PlatformAdapter, PlatformEvent } from '../adapter';

const listeners: Map<PlatformEvent, Set<() => void>> = new Map();

export const standaloneAdapter: PlatformAdapter = {
  name: 'standalone',

  async init({ gameId, version }) {
    console.info('[platform:standalone] init', { gameId, version });
  },

  loadingStart() {
    console.debug('[platform:standalone] loadingStart');
  },
  loadingProgress(f) {
    console.debug('[platform:standalone] loadingProgress', f);
  },
  loadingComplete() {
    console.debug('[platform:standalone] loadingComplete');
  },
  gameplayStart() {
    console.debug('[platform:standalone] gameplayStart');
  },
  gameplayStop() {
    console.debug('[platform:standalone] gameplayStop');
  },
  happyTime(intensity) {
    console.debug('[platform:standalone] happyTime', intensity ?? 1);
  },

  showInterstitial: () => Promise.resolve({ shown: false }),
  showRewarded: () => Promise.resolve({ completed: true }),
  isAdBlocked: () => false,

  async saveData(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.warn('[platform:standalone] saveData failed', err);
    }
  },

  async loadData<T>(key: string, defaultValue: T): Promise<T> {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? defaultValue : (JSON.parse(raw) as T);
    } catch (err) {
      console.warn('[platform:standalone] loadData failed', err);
      return defaultValue;
    }
  },

  trackEvent(name, props) {
    console.info('[platform:standalone] event', name, props ?? {});
  },

  capabilities: {
    hasOwnPauseButton: false,
    hasOwnMuteButton: false,
    hasOwnFullscreen: false,
    supportsHaptics: false,
    showsBranding: false,
  },

  on(event, handler) {
    let set = listeners.get(event);
    if (!set) {
      set = new Set();
      listeners.set(event, set);
    }
    set.add(handler);
    return () => listeners.get(event)?.delete(handler);
  },
};
